var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 21C2.19167 21 1.64236 20.7715 1.18542 20.3146C0.728472 19.8576 0.5 19.3083 0.5 18.6667V2.33333C0.5 1.69167 0.728472 1.14236 1.18542 0.685417C1.64236 0.228472 2.19167 0 2.83333 0H15.6667L21.5 5.83333V18.6667C21.5 19.3083 21.2715 19.8576 20.8146 20.3146C20.3576 20.7715 19.8083 21 19.1667 21H2.83333ZM2.83333 18.6667H19.1667V7H14.5V2.33333H2.83333V18.6667ZM5.16667 16.3333H16.8333V14H5.16667V16.3333ZM5.16667 7H11V4.66667H5.16667V7ZM5.16667 11.6667H16.8333V9.33333H5.16667V11.6667Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/newsIcon.45e3877d0ca72cf1a02ddea8ba0d712e.svg";
export { ForwardRef as ReactComponent };